import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import StepWizard from "react-step-wizard";
import Step1 from "../EntraJobControl/Step1";
import Step2 from "../EntraJobControl/Step2";
import Step3 from "../EntraJobControl/Step3";
import { AppContext } from "../MainComponents/AppContext";
const EntraJobControlPopup = (props) => {
    const [stepWizrd, setStepWizard] = useState(null);
    const [activeStep, setActiveStep] = useState(0);
    const [appContext] = useContext(AppContext);
    const handleStepChange = (e) => {
        setActiveStep(e.activeStep - 1);
    };
    const assignStepWizard = (instance) => {
        setStepWizard(instance);
    };
    const closeJobControlPopup = () => {
        stepWizrd.goToStep(1);
        stepWizrd.isActive = false;
        setActiveStep(0)
        appContext.entraJob = {
            jobID: 0,
            name: "",
            description: "",
            selectedItems: [],
            schedule: 0,
            isEditJob: false
        }
        props.refresh();
        props.closeModal(true);
    }
    const closeModal = () => {
        closeJobControlPopup();
        props.closeModal(true);
    }
    return (
        <Modal show={props.entraJobPopup} onHide={closeModal} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>{appContext.entraJob.isEditJob? "Edit Job" : "New Job" }</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div className="horizontal-stepper">
                        <div className={`h-step ${activeStep === 0 ? " active" : (activeStep > 0 ? " completed" : "")}`}>
                            <div className="circle">
                                <span>1</span>
                            </div>
                            <div className="content">Job Detail</div>
                            <div className="line"></div>
                        </div>
                        <div className={`h-step ${activeStep === 1 ? " active" : (activeStep > 1 ? " completed" : "")}`}>
                            <div className="circle"><span>2</span></div>
                            <div className="content">Select Items</div>
                            <div className="line"></div>
                        </div>
                        <div className={`h-step ${activeStep === 2 ? " active" : (activeStep > 2 ? " completed" : "")}`}>
                            <div className="circle"><span>3</span></div>
                            <div className="content">Schedule & Confirm</div>
                            <div className="line"></div>
                        </div>
                    </div>
                </div>
                <StepWizard isLazyMount instance={assignStepWizard} currentStep={activeStep} onStepChange={handleStepChange}>
                    <Step1 closePopupModal={closeModal} />
                    <Step2 closePopupModal={closeModal} />
                    <Step3 closePopupModal={closeModal} />
                </StepWizard>
            </Modal.Body>
        </Modal>
    );
}
export default EntraJobControlPopup;